<template>
  <div class="shop_cart_page">
    <div class="page_top_img_container life_bk_block">
      <img src="@/assets/images/shop/index/banner.png" class="top_banner">
      <div class="title_with_line">
        <div class="title_line"><span>网上商城</span></div>
        <div class="title_e">Online Shopping Mall</div>
      </div>
      <div class="content_container">
        <div class="mmc_title_with_line">购物车</div>
      </div>
      <div class="product_list">
        <el-checkbox-group v-model="checkList" class="cart_pro_list">
          <el-checkbox v-for="(item,index) in newArr" :key="index">
            <img :src="item.proId==1?pro1Img:pro2Img" alt="">
            <div class="pro_name">
              <div class="name_show">{{item.proName}}</div>
              <div class="price_show">¥<span>{{item.proPrice}}</span><small>×{{item.count}}</small></div>
            </div>
            <el-button round size="mini" @click="delPro(item.proId)">删除</el-button>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="bottom_total">
        <span>已选商品{{totalNum}}件，合计：</span>
        <strong class="price">¥<span>{{totalPrice}}</span>.00</strong>
        <el-button type="text" @click="$router.push('/login')"><strong>结算</strong></el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      cartList:JSON.parse(localStorage.getItem('zhizhongcarts')),
      pro1Img:require('@/assets/images/shop/index/pic1.png'),
      pro2Img:require('@/assets/images/shop/index/pic2.png'),
      pro3Img:require('@/assets/images/shop/index/pic3.png'),
      checkList:[],
      proDetailList:[
        {proId:1,proName:'OMRON 蓝牙智能血压计 U32K 智能健康管家',
          proDesc:'新品上市，智能健康管家，为您定制血压管理解决方案',
          proPrice:'xxx'
        },
        {proId:2,proName:'OMRON 欧姆龙智能血压计 HEM-9200K',
          proDesc:'革新健康方式，开启香槟人生',
          proPrice:'xxx'
        },
        {proId:3,proName:'MMC血糖院外管理套餐',
            proDesc:'90天血糖随访管理+MMC血糖仪+50片血糖试纸+50支采血针',
            proPrice:'xxx'
        }
      ],
      newArr:[]
    }
  },
  computed:{
    totalNum(){
      var total = 0
      for(let i in this.newArr){
        total += this.newArr[i].count
      }
      return total
    },
    totalPrice(){
      let totalP = 0
      for(let i in this.newArr){
        totalP += this.newArr[i].proPrice * this.newArr[i].count
      }
      return totalP
    }
  },
  beforeMount(){
    let hasProList = this.proDetailList.filter(item=>{
      for(let i in this.cartList){
        if(this.cartList[i].proId == item.proId){
          return item
        }
      }
    })
    for(let i in hasProList){
      this.newArr.push(Object.assign(this.cartList[i], hasProList[i]))
    }
    this.newArr = this.newArr.filter(item=>item.userName == this.$store.state.userName)
  },
  methods:{
    delPro(proId){
      const newList = this.newArr.filter(item=>item.proId !== proId && item.userName == this.$store.state.userName)
      localStorage.setItem('zhizhongcarts',JSON.stringify(newList))
      this.$router.go(0)
    }
  }
};
</script>

<style lang="less">
.shop_cart_page{
  position: relative;
  .content_container,.product_list{
    width: 88%;
    margin: 0 auto;
  }
  .product_list{
    padding-bottom: 50px;
    min-height: 600px;
    .el-checkbox{
      padding: 27px 10px;
      border-top: 1px solid #DCDCDC;
      display: block;
      margin-right: 0px;
      .el-checkbox__input{
        transform: scale(1.7);
        margin-right: 30px;
        .el-checkbox__inner{
          border-radius: 50%;
        }
      }
      .el-checkbox__label{
        img{
          width: 140px;
          height: 140px;
        }
      }
      &:last-of-type{
        border-bottom: 1px solid #DCDCDC;
      }
    }
    .cart_pro_list{
      position: relative;
      .pro_name{
        display: inline-block;
        font-size: 24px;
        line-height: 35px;
        margin-left: 16px;
        color: #000;
        .price_show{
          margin-top: 16px;
          span{
            font-size: 32px;
          }
        }
      }
      .el-button{
        position: absolute;
        right: 0;
        top: calc(50% - 12.5px);
        width: 117px;
        height: 35px;
        padding: 0;
        font-size: 16px;
        line-height: 35px;
        background: #A0A0A0;
        color: #fff;
      }
    }
  }
  .bottom_total{  //结算
    background: #E9E9E9;
    height: 60px;
    width: 100%;
    max-width: 1170px;
    position: absolute;
    bottom: 0;
    text-align: right;
    font-size: 18px;
    &>span{
      vertical-align: middle;
    }
    .price{
      font-size: 24px;
      color: #EC7700;
      vertical-align: middle;
      span{
        font-size: 32px;
        line-height: 35px;
      }
    }
    .el-button{
      margin-left: 25px;
      height: 100%;
      width: 181px;
      background-color: #0093DD;
      border-radius: 0;
      text-align: center;
      color: #fff;
      font-size: 24px;
      letter-spacing: .3em;
    }
  }
}
</style>
